export const styles = {
    container: {
        padding: '10px',
        fontFamily: 'Arial, sans-serif',
        maxWidth: '100%', // Assegura que não ultrapassa a largura do dispositivo
        margin: 'auto',
    },
    titulo: {
        textAlign: 'center',
        color: '#302e32',
        margin: '10px 0',
        fontSize: '18px', // Maior para visibilidade em dispositivos móveis
    },
    descricao: {
        textAlign: 'center',
        marginBottom: '10px',
        color: '#646464',
        fontSize: '16px', // Ajustado para melhor leitura
    },
    botaoAdicionar: {
        display: 'block',
        margin: '0 auto 10px',
        padding: '12px 24px', // Maior para facilitar toques
        backgroundColor: '#4CAF50',
        color: '#FFFFFF',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        fontSize: '16px', // Tamanho de fonte maior para legibilidade
    },
    itemPlataforma: {
        marginBottom: '10px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: '#f0e9fd',
        padding: '10px',
        borderRadius: '5px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    },
    edit: {
        width: '80%',
        backgroundColor: '#fafafc',
    },
    botaoAcao: {
        margin: '10px 0', // Aumenta o espaçamento para evitar toques acidentais
        padding: '10px 20px', // Aumenta o padding para facilitar toques
        border: '1px solid #ddd',
        backgroundColor: '#fff',
        cursor: 'pointer',
        fontSize: '16px', // Tamanho de fonte maior para legibilidade
    }
};
